import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { domainEnvironment } from '@awread/global/environments';

/**
 * Khoá localStorage giữ đường dẫn cần quay lại sau khi đăng nhập/đăng ký (vd: đang nạp xu ở
 * /paying/coin mà chưa đăng nhập). Chỉ nhận đường dẫn nội bộ, dùng xong là xoá.
 */
export const RETURN_URL_KEY = 'returnUrl';
/** Khách mở dialog rồi bỏ đi không đăng nhập thì key vẫn nằm lại -> chỉ dùng trong 30 phút, quá là coi như không có. */
const RETURN_URL_TTL_MS = 30 * 60 * 1000;

function isInternalPath(url: string | null | undefined): url is string {
  return !!url && url.startsWith('/') && !url.startsWith('//');
}

function readReturnUrl(): string | null {
  if (typeof localStorage === 'undefined') return null;
  try {
    const raw = localStorage.getItem(RETURN_URL_KEY);
    if (!raw) return null;
    const { url, at } = JSON.parse(raw);
    if (!isInternalPath(url) || typeof at !== 'number' || Date.now() - at > RETURN_URL_TTL_MS) return null;
    return url;
  } catch {
    return null;
  }
}

export function saveReturnUrl(url: string | null | undefined) {
  if (typeof localStorage === 'undefined' || !isInternalPath(url)) return;
  localStorage.setItem(RETURN_URL_KEY, JSON.stringify({ url, at: Date.now() }));
}

/** Lấy rồi xoá luôn, mỗi returnUrl chỉ dùng đúng một lần. */
export function takeReturnUrl(): string | null {
  const url = readReturnUrl();
  if (typeof localStorage !== 'undefined') localStorage.removeItem(RETURN_URL_KEY);
  return url;
}

export function hasReturnUrl() {
  return readReturnUrl() !== null;
}

@Injectable({ providedIn: 'root' })
export class AuthRoutingGear {
  loginCompleteRoute = '/profile';
  registerCompleteRoute = '/profile';
  constructor(private router: Router) {}

  navigateAfterCreateAccount(router: string = '/single/profile') {
    this.router.navigate([router]);
  }

  navigateAfterRegisterCompleted(router: string = '/') {
    this.router.navigateByUrl(takeReturnUrl() ?? router);
  }

  navigateRegister() {
    this.router.navigateByUrl('/register');
  }
  /** Có returnUrl (khách bị chặn giữa chừng, vd đang nạp xu) thì quay lại đúng chỗ đó thay vì trang chủ. */
  navigateHome() {
    this.router.navigateByUrl(takeReturnUrl() ?? '/');
  }
  navigateToActiveAccount() {
    this.router.navigateByUrl('/active');
  }
}
